import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.BranchMonthlyDeliveryPipeline.';
  public static readonly purchaseOrderNo = `${Id.prefix}purchaseOrderNo`;
  public static readonly purchaseOrderTitle = `${Id.prefix}purchaseOrderTitle`;
  public static readonly mfgRef = `${Id.prefix}mfgRef`;
  public static readonly mfgStatus = `${Id.prefix}mfgStatus`;
  public static readonly proposedDelivery = `${Id.prefix}proposedDelivery`;
  public static readonly mfgDelivery = `${Id.prefix}mfgDelivery`;
  public static readonly deliveryPipeline = `${Id.prefix}deliveryPipeline`;
  public static readonly deliveryPipelineTooltip = `${Id.prefix}deliveryPipelineTooltip`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDashboardBranchMonthlyDeliveryPipeline {
  private constructor() {}

  public static purchaseOrderNo(): string {
    return interpolate(Id.purchaseOrderNo);
  }

  public static purchaseOrderTitle(): string {
    return interpolate(Id.purchaseOrderTitle);
  }

  public static mfgRef(): string {
    return interpolate(Id.mfgRef);
  }

  public static mfgStatus(): string {
    return interpolate(Id.mfgStatus);
  }

  public static proposedDelivery(): string {
    return interpolate(Id.proposedDelivery);
  }

  public static mfgDelivery(): string {
    return interpolate(Id.mfgDelivery);
  }

  public static deliveryPipeline(): string {
    return interpolate(Id.deliveryPipeline);
  }

  public static deliveryPipelineTooltip(): string {
    return interpolate(Id.deliveryPipelineTooltip);
  }
}

export class DashboardBranchMonthlyDeliveryPipelineModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderNo,
      "{{glossary 'purchase-order-abbrev'}} No.",
      'Column title for purchase order number'
    );
    register.add(
      Id.purchaseOrderTitle,
      "{{glossary 'purchase-order-abbrev'}} Title",
      'Column title for purchase order title'
    );
    register.add(Id.mfgRef, 'MFG Ref.', 'Column title for manufacturer reference');
    register.add(Id.mfgStatus, 'MFG Status', 'Column title for manufacturer status');
    register.add(Id.proposedDelivery, 'Proposed Delivery', 'Column title for proposed delivery date');
    register.add(Id.mfgDelivery, 'MFG Delivery', 'Column title for manufacturer delivery date');
    register.add(Id.deliveryPipeline, 'Delivery Pipeline', 'Header for delivery pipeline widget');
    register.add(
      Id.deliveryPipelineTooltip,
      'Delivery pipeline is displaying the next 14 days.',
      'Tooltip message informing delievery pipeline has the 14-day record limit'
    );
  }
}
